import { render, staticRenderFns } from "./AdminDashboardExpiringRequestsListItem.vue?vue&type=template&id=192bca8c"
import script from "./AdminDashboardExpiringRequestsListItem.vue?vue&type=script&lang=js"
export * from "./AdminDashboardExpiringRequestsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports